import React from "react";
import { Link, useHistory } from "react-router-dom";
import "./NotFound.css";

const NotFound = () => {
  const history = useHistory();

  return (
    <div className="notfound-page">
      <div className="notfound-card">
        <span className="notfound-code">404</span>
        <div className="notfound-divider" />
        <h1>Page introuvable</h1>
        <p>
          La page que vous recherchez n'existe pas ou a été déplacée.
          <br />
          Vérifiez l'adresse ou revenez à l'accueil.
        </p>
        <div className="notfound-actions">
          <Link to="/" className="notfound-button notfound-button--primary">
            Retour à l'accueil
          </Link>
          <button
            type="button"
            className="notfound-button notfound-button--secondary"
            onClick={() => history.goBack()}
          >
            Page précédente
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
